export default __webpack_public_path__ + "static/media/field-bg.a5588f7a.png";